import { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { mensagemErro } from '../api/axios';
import { Marca } from '../components/common';
import { useAuth } from '../contexts/AuthContext';

const RE_EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function Login() {
  const { entrar, usuario, carregando } = useAuth();
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [manterConectado, setManterConectado] = useState(true);
  const [erros, setErros] = useState({});
  const [erroGeral, setErroGeral] = useState('');
  const [enviando, setEnviando] = useState(false);

  if (!carregando && usuario) return <Navigate to="/dashboard" replace />;

  const submeter = async (e) => {
    e.preventDefault();
    setErroGeral('');

    // Validação no submit, como especificado no handoff.
    const novos = {};
    if (!email.trim()) novos.email = 'Informe o e-mail.';
    else if (!RE_EMAIL.test(email.trim())) novos.email = 'E-mail inválido.';
    if (!senha) novos.senha = 'Informe a senha.';
    setErros(novos);
    if (Object.keys(novos).length) return;

    setEnviando(true);
    try {
      await entrar(email.trim(), senha);
      navigate('/dashboard');
    } catch (err) {
      setErroGeral(mensagemErro(err, 'Não foi possível entrar. Tente novamente.'));
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="ff-login-tela">
      <div className="ff-login-card">
        {/* ── Painel de marca ─────────────────────────────────────────── */}
        <aside className="ff-login-marca">
          <div className="ff-login-marca__ornamento ff-login-marca__ornamento--g" aria-hidden="true" />
          <div className="ff-login-marca__ornamento ff-login-marca__ornamento--p" aria-hidden="true" />

          <img
            className="ff-login-marca__logo"
            src={`${process.env.PUBLIC_URL}/logo-eliel-branco.png`}
            alt="Eliel Figueirêdo Laboratório e Imagem"
          />

          <div>
            <div className="ff-login-marca__sistema">
              <Marca tamanho={40} />
              <span className="ff-login-marca__nome">FluxFin</span>
            </div>
            <p className="ff-login-marca__texto">
              Controle de recebimentos, protocolos e conferência de guias das operadoras.
            </p>
          </div>

          <div>
            <span className="ff-eyebrow ff-login-marca__uso">Uso interno</span>
            <p className="ff-login-marca__razao">
              Eliel Figueirêdo Diagnósticos Médicos de Apoio Ltda
            </p>
          </div>
        </aside>

        {/* ── Formulário ──────────────────────────────────────────────── */}
        <main className="ff-login-form">
          <form className="ff-login-form__inner" onSubmit={submeter} noValidate>
            <div>
              <h1>Acessar o FluxFin</h1>
              <p className="ff-login-form__sub">
                Entre com as credenciais do seu e-mail corporativo.
              </p>
            </div>

            {erroGeral && (
              <div className="ff-aviso ff-aviso--erro" role="alert" style={{ margin: 0 }}>
                <i className="bi bi-exclamation-octagon" aria-hidden="true" />
                <div>{erroGeral}</div>
              </div>
            )}

            <div className="ff-login-campos">
              <div className={`ff-campo${erros.email ? ' ff-campo--erro' : ''}`}>
                <label htmlFor="email">E-mail</label>
                <input
                  id="email"
                  type="email"
                  className="ff-input"
                  placeholder="nome@elielfigueiredo.com.br"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  autoComplete="username"
                  disabled={enviando}
                  aria-invalid={erros.email ? 'true' : undefined}
                  aria-describedby={erros.email ? 'email-erro' : undefined}
                  autoFocus
                />
                {erros.email && (
                  <span className="ff-erro-msg" id="email-erro">
                    {erros.email}
                  </span>
                )}
              </div>

              <div className={`ff-campo${erros.senha ? ' ff-campo--erro' : ''}`}>
                <label htmlFor="senha">Senha</label>
                <input
                  id="senha"
                  type="password"
                  className="ff-input"
                  placeholder="••••••••••"
                  value={senha}
                  onChange={(e) => setSenha(e.target.value)}
                  autoComplete="current-password"
                  disabled={enviando}
                  aria-invalid={erros.senha ? 'true' : undefined}
                  aria-describedby={erros.senha ? 'senha-erro' : undefined}
                />
                {erros.senha && (
                  <span className="ff-erro-msg" id="senha-erro">
                    {erros.senha}
                  </span>
                )}
              </div>
            </div>

            <div className="ff-login-linha">
              <label className="ff-login-check" htmlFor="manter">
                <input
                  id="manter"
                  type="checkbox"
                  checked={manterConectado}
                  onChange={(e) => setManterConectado(e.target.checked)}
                  disabled={enviando}
                />
                Manter conectado
              </label>
              <a className="ff-login-esqueci" href="#esqueci">
                Esqueci a senha
              </a>
            </div>

            <button
              type="submit"
              className="ff-btn ff-btn--primario ff-login-entrar"
              disabled={enviando}
            >
              {enviando ? 'Entrando…' : 'Entrar'}
            </button>

            <div className="ff-login-rodape">
              <span className="ff-login-rodape__ponto" aria-hidden="true" />
              Ambiente de produção · v1.0
            </div>
          </form>
        </main>
      </div>
    </div>
  );
}
